<template>
    <div class="ChineseLibClassify">
        <div class="title">中图分类</div>
        <div class="type-list-view">
              <div class="list-item" v-for="(item, index) of records" :key="index">
                {{item.type}} ({{item.count}})
            </div>
        </div>
    </div>
</template>

<script>
import statisticsApi from '@/api/statistics'

export default {
    data () {
        return {
            records: [],
            pageIndex: 1,
            pageSize: 30,
            recordsDisplay: []
        }
    },
    mounted () {
        this.getData();
    },
    methods: {
        getData () {
            let that = this;
            statisticsApi.getSubItemTypeStatistics({
                type: 'all',
                subType: 'schema',
                libraryCode: this.global.getLibraryInfos().code
            })
            .then((response) => {
                console.log(response);
                that.records = response.data;
            });
        },
        changeTablePage (index) {
            this.pageIndex = index;
            this.showData();
        }
    }
};
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";

.ChineseLibClassify {
     width: 400 * @uw;
    height: 450 * @uw;
    box-shadow: 0px 0px 10px 5px #e0e0e0;

    .title {
        font-size: 16 * @uw;
        color: #8d5e1a;
        margin: 0 * @uh 0px 20 * @uh 10 * @uw;
        padding-top: 10 * @uh;
    }

    .type-list-view {
        display: flex;
        flex-direction: column;
        margin-left: 20 * @uw;
        margin-right: 20 * @uw;
        overflow: scroll;
        height: 360 * @uw;

        .list-item {
            border-bottom: dashed 1px grey;
            padding: 10 * @uh 0px 10 * @uh 0px;
        }
    }

    .pagination {
        width: 90%;
    }
}
</style>
